/* if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form && this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
 class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.update.bind(this));
    this.update();
    this.querySelector('.sticky-cart-button').addEventListener('click', this.onClickHandler.bind(this));
    this.querySelector('.sticky-cart-button').addEventListener('keydown', this.onClickKeydownHandler.bind(this));
  }
  update(){
    var button = document.getElementById(`product-form-${this.dataset.section}`);
    var sect = this.closest('.shopify-section')||this.closest('.popup-modal__content__data');
    var addButton = sect.querySelector('select-option-js')?button.querySelector('.select-options-button'):button.querySelector('[name="add"]');
    const rangeToShowModal = this.getTop(addButton) + addButton.clientHeight;

    if(rangeToShowModal <= 0) return false;
    if(window.scrollY >= rangeToShowModal && !this.classList.contains('show-modal')){
      this.classList.add('show-modal');
      document.querySelector('body').classList.add('modal__sticky-cart');
      document.querySelector('.footer__content').classList.add('sticky-cart-modal_bottom_padding');
    }
    if(window.scrollY < rangeToShowModal && this.classList.contains('show-modal')){
      this.classList.remove('show-modal');
      document.querySelector('body').classList.remove('modal__sticky-cart');
    }
  }
  onClickKeydownHandler(){
    if(event.code.toUpperCase() !== 'ENTER') return false;
    this.onClickHandler();
  }
  onClickHandler(){
    var item = document.querySelector(`.product__column__content [id*="variant-selects-"]`),
        btn_item = document.getElementById("product-container"),
        _y = (item ? this.getTop(item) : this.getTop(btn_item)) - 20;
    this.scrollTo(_y,700);
  }
  getTop(el) {
    return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
  }
  scrollTo(to, duration) {
    const element = document.scrollingElement || document.documentElement,
          start = element.scrollTop,
          change = to - start,
    animateScroll = function() {
      element.scrollTop = to;
    };
    animateScroll();
  }
} 

customElements.define('sticky-cart-modal', stickyCartModal); */

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form && this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading-overlay__spinner');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );

          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);

              const buttonText = this.submitButton.querySelector('span');

              if (buttonText) {
                buttonText.classList.add('hidden');
              }

              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            const spinner = this.querySelector('.loading-overlay__spinner');

            if (spinner) {
              spinner.classList.add('hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

if (!customElements.get('sticky-cart-modal')) {
  class StickyCartModal extends HTMLElement {
    constructor() {
      super();

      this.initialized = false;
      this.isAdding = false;
      this.mainButtonInView = false;
      this.observer = null;

      this.boundFallbackVisibilityCheck = this.fallbackVisibilityCheck.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.stickyButton = this.querySelector('.sticky-cart-button');
      this.originalButtonText = this.getCurrentStickyButtonText() || 'Add to Cart';

      this.injectSafeAreaCSS();

      /**
       * Start hidden.
       * Intersection Observer will decide whether to show it.
       * This prevents a small flash when the real ATC is already visible.
       */
      this.hideStickyCart();

      this.forceOnlyOneAddToCartTextVisible();

      if (this.stickyButton) {
        this.stickyButton.addEventListener('click', this.onClickHandler.bind(this));
        this.stickyButton.addEventListener('keydown', this.onClickKeydownHandler.bind(this));
      }

      this.initMainButtonObserver();
    }

    injectSafeAreaCSS() {
      if (document.getElementById('sticky-cart-safe-area-style')) return;

      const style = document.createElement('style');
      style.id = 'sticky-cart-safe-area-style';

      style.textContent = `
        sticky-cart-modal {
          padding-bottom: env(safe-area-inset-bottom);
        }

        sticky-cart-modal .sticky-cart {
          padding-bottom: env(safe-area-inset-bottom);
        }

        sticky-cart-modal.sticky-cart-hidden {
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
          transform: translateY(120%) !important;
        }

        sticky-cart-modal.show-modal {
          opacity: 1;
          visibility: visible;
          pointer-events: auto;
          transform: translateY(0);
        }
      `;

      document.head.appendChild(style);
    }

    getProductForm() {
      return document.getElementById(`product-form-${this.dataset.section}`);
    }

    getMainActionButton() {
      const productForm = this.getProductForm();

      if (!productForm) return null;

      const realAddButton = productForm.querySelector('[name="add"]');
      const selectOptionsButton = productForm.querySelector('.select-options-button');

      return realAddButton || selectOptionsButton || null;
    }

    initMainButtonObserver() {
      const mainButton = this.getMainActionButton();

      if (!mainButton) {
        /**
         * Fallback:
         * If the real button is not found, show sticky ATC
         * so the customer still has a CTA.
         */
        this.showStickyCart();
        return;
      }

      this.mainActionButton = mainButton;

      /**
       * Immediate check before observer callback runs.
       */
      this.updateStickyVisibilityByElement(mainButton);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];

            if (!entry) return;

            this.mainButtonInView = entry.isIntersecting && entry.intersectionRatio > 0;

            if (this.mainButtonInView) {
              this.hideStickyCart();
            } else {
              this.showStickyCart();
            }
          },
          {
            root: null,
            threshold: 0.01
          }
        );

        this.observer.observe(mainButton);
      } else {
        /**
         * Older browser fallback.
         */
        window.addEventListener('scroll', this.boundFallbackVisibilityCheck, { passive: true });
        window.addEventListener('resize', this.boundFallbackVisibilityCheck);

        this.fallbackVisibilityCheck();
      }
    }

    updateStickyVisibilityByElement(element) {
      const rect = element.getBoundingClientRect();

      const isVisible =
        rect.top < window.innerHeight &&
        rect.bottom > 0 &&
        rect.left < window.innerWidth &&
        rect.right > 0;

      this.mainButtonInView = isVisible;

      if (isVisible) {
        this.hideStickyCart();
      } else {
        this.showStickyCart();
      }
    }

    fallbackVisibilityCheck() {
      const mainButton = this.mainActionButton || this.getMainActionButton();

      if (!mainButton) {
        this.showStickyCart();
        return;
      }

      this.updateStickyVisibilityByElement(mainButton);
    }

    showStickyCart() {
      if (this.mainButtonInView) return;

      this.classList.add('show-modal');
      this.classList.remove('sticky-cart-hidden');

      document.body.classList.add('modal__sticky-cart');

      const footerContent = document.querySelector('.footer__content');

      if (footerContent) {
        footerContent.classList.add('sticky-cart-modal_bottom_padding');
      }
    }

    hideStickyCart() {
      this.classList.remove('show-modal');
      this.classList.add('sticky-cart-hidden');

      document.body.classList.remove('modal__sticky-cart');

      const footerContent = document.querySelector('.footer__content');

      if (footerContent) {
        footerContent.classList.remove('sticky-cart-modal_bottom_padding');
      }
    }

    getTextSpan(container) {
      if (!container) return null;

      const directSpans = Array.from(container.children).filter((child) => {
        return child.tagName && child.tagName.toLowerCase() === 'span';
      });

      return directSpans.length ? directSpans[directSpans.length - 1] : null;
    }

    getTopAddToCartText() {
      const topAddText = this.querySelector('.btn__top-text.add_to_cart__text');
      return this.getTextSpan(topAddText);
    }

    getBottomAddToCartText() {
      const bottomAddText = this.querySelector('.btn__bottom-text.add_to_cart__text');
      return this.getTextSpan(bottomAddText);
    }

    getCurrentStickyButtonText() {
      const topTextSpan = this.getTopAddToCartText();

      if (!topTextSpan) return '';

      return topTextSpan.textContent.trim();
    }

    forceOnlyOneAddToCartTextVisible() {
      const topAddText = this.querySelector('.btn__top-text.add_to_cart__text');
      const bottomAddText = this.querySelector('.btn__bottom-text.add_to_cart__text');
      const selectOptionsTexts = this.querySelectorAll('.select_options__text');

      if (topAddText) {
        topAddText.classList.remove('is-hidden');
        topAddText.classList.add('is-visible');
        topAddText.style.removeProperty('display');
        topAddText.style.removeProperty('opacity');
        topAddText.style.removeProperty('visibility');
      }

      if (bottomAddText) {
        bottomAddText.classList.remove('is-visible');
        bottomAddText.classList.add('is-hidden');
        bottomAddText.style.setProperty('display', 'none', 'important');
      }

      selectOptionsTexts.forEach((item) => {
        item.classList.remove('is-visible');
        item.classList.add('is-hidden');
        item.style.setProperty('display', 'none', 'important');
      });
    }

    setStickyButtonText(text) {
      this.forceOnlyOneAddToCartTextVisible();

      const topTextSpan = this.getTopAddToCartText();
      const bottomTextSpan = this.getBottomAddToCartText();

      if (topTextSpan) {
        topTextSpan.textContent = text;
      }

      /**
       * Keep hidden bottom text updated too.
       * This avoids animation mismatch if theme later uses it.
       */
      if (bottomTextSpan) {
        bottomTextSpan.textContent = text;
      }
    }

    setStickyLoading(isLoading) {
      this.isAdding = isLoading;

      if (isLoading) {
        this.setStickyButtonText('Adding to Cart...');

        /**
         * Do NOT add theme's "loading" class here.
         * Some themes hide button text when .loading is added.
         */
        if (this.stickyButton) {
          this.stickyButton.setAttribute('aria-busy', 'true');
          this.stickyButton.style.pointerEvents = 'none';
          this.stickyButton.style.opacity = '1';
        }
      } else {
        this.setStickyButtonText(this.originalButtonText || 'Add to Cart');

        if (this.stickyButton) {
          this.stickyButton.removeAttribute('aria-busy');
          this.stickyButton.style.pointerEvents = '';
          this.stickyButton.style.opacity = '';
        }

        /**
         * Re-check visibility after add-to-cart finishes.
         * If the main ATC is visible, sticky should stay hidden.
         */
        const mainButton = this.mainActionButton || this.getMainActionButton();

        if (mainButton) {
          this.updateStickyVisibilityByElement(mainButton);
        }
      }
    }

    waitForMainButtonToFinish(realAddButton) {
      let attempts = 0;
      const maxAttempts = 100;

      const checkLoading = setInterval(() => {
        attempts++;

        const stillLoading =
          realAddButton.classList.contains('loading') ||
          realAddButton.getAttribute('aria-disabled') === 'true';

        if (!stillLoading || attempts >= maxAttempts) {
          clearInterval(checkLoading);
          this.setStickyLoading(false);
        }
      }, 100);
    }

    onClickKeydownHandler(event) {
      if (event.code.toUpperCase() !== 'ENTER') return false;
      this.onClickHandler();
    }

    onClickHandler() {
      if (this.isAdding) return;

      const productForm = this.getProductForm();

      if (!productForm) {
        console.warn('Sticky ATC: Product form not found');
        return;
      }

      const realAddButton = productForm.querySelector('[name="add"]');
      const selectOptionsButton = productForm.querySelector('.select-options-button');

      if (realAddButton) {
        if (
          realAddButton.disabled ||
          realAddButton.getAttribute('aria-disabled') === 'true'
        ) {
          this.scrollToProductOptions();
          return;
        }

        this.setStickyLoading(true);

        /**
         * This triggers your existing product-form AJAX submit logic.
         */
        realAddButton.click();

        this.waitForMainButtonToFinish(realAddButton);

        return;
      }

      if (selectOptionsButton) {
        selectOptionsButton.click();
        return;
      }

      console.warn('Sticky ATC: Add to Cart button not found');
      this.scrollToProductOptions();
    }

    scrollToProductOptions() {
      const item = document.querySelector(`.product__column__content [id*="variant-selects-"]`);
      const btnItem = document.getElementById('product-container');
      const target = item || btnItem;

      if (!target) return;

      const y = this.getTop(target) - 20;
      this.scrollTo(y);
    }

    getTop(el) {
      if (!el) return 0;
      return el.offsetTop + (el.offsetParent ? this.getTop(el.offsetParent) : 0);
    }

    scrollTo(to) {
      const element = document.scrollingElement || document.documentElement;

      element.scrollTo({
        top: to,
        behavior: 'smooth'
      });
    }
  }

  customElements.define('sticky-cart-modal', StickyCartModal);
}